import { Fragment, ReactElement } from 'react';
import { Outlet } from 'react-router-dom';

const Things = (): ReactElement => {
  return (
    <Fragment>
      <Outlet />
    </Fragment>
  );
};
export default Things;
